var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[_vm.$style.titles, _vm.center ? _vm.$style.titlesCentered : '']},[_c('h1',[_vm._v(" "+_vm._s(_vm.title)+" ")]),(_vm.intro)?_c('h2',[_vm._v(" "+_vm._s(_vm.intro)+" ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }